
import { BaseResponse } from '../baseresponse';
import { Agent } from '../../../model/shared/user/user';
export class PayoutAgent {
  id: string;
  name: string;
}

export class PayoutAgentList {
  total: number;
  list: Array<PayoutAgent>;
}

export class AgentListResult extends BaseResponse {
  data: Array<Agent>;
}

export class AgentDetailResult extends BaseResponse {
  data: Agent;
}

export class PayoutBranch {
  partner_id: string;
  name: string;
  branch_code: string;
  branch_type: string;
  bank_code: string;
  charge_type: string;
  partner_name: string;
  reg_date?: string;
  address?: string;
  manager?: string;
  phone?: string;
}

export class HimalMasterBranch implements PayoutBranch {
  partner_id: string = '0001';
  name: string = 'All Branch';
  branch_code: string = '699';
  bank_code: string = '2';
  branch_type: string = 'Payout';
  charge_type: string = 'Cash';
  partner_name: string = 'Himal Remit';
}


export class PayoutBranchList {
  total: number;
  list: Array<PayoutBranch>;
}

export class PayoutBranchListResult extends BaseResponse {
  data: PayoutBranchList;
}

export class PayoutBankListResult extends BaseResponse {
  data: PayoutBankList;
}

export class PayoutBankList {
  total: number;
  list: Array<PayoutBank>;
}


export class PayoutBank {
  name: string;
  bank_code: string;
  partner_id;
}

export enum PayoutBranchQueryMode {
  Full, NameCode, NameCodePtn
}

export class PayoutBranchQueryModeUtil {
  static toQueryParam(querymode: PayoutBranchQueryMode) {
    if (querymode === PayoutBranchQueryMode.Full) {
      return 'pb_full';
    } else if (querymode === PayoutBranchQueryMode.NameCode) {
      return 'pb_name_code';
    } else if (querymode === PayoutBranchQueryMode.NameCodePtn) {
      return 'pb_name_code_ptn';
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/response/internal/list/agentlistresult.ts